import { render, staticRenderFns } from "./FPEmbebed.vue?vue&type=template&id=67514a92&scoped=true"
import script from "./FPEmbebed.vue?vue&type=script&lang=js"
export * from "./FPEmbebed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67514a92",
  null
  
)

export default component.exports